import React from "react";
import { urlFor } from "../client";
import Loading from "./Loading/Loading";

const SingleBlog = ({ singleBlog }) => {
  console.log(singleBlog);
  return (
    <>
      {singleBlog ? (
        <div id="singleBlog">
          <div className="gradient"></div>
          <div className="gradient2"></div>
          <div className="publish">
            <small>
              By <span>Laser Treat</span> at <span>{singleBlog.location}</span>{" "}
              on <span>{singleBlog.dop}</span>
            </small>
          </div>
          <img src={urlFor(singleBlog.blogimg)} alt="" className="bigBanner" />

          <div className="title">
            <h1>{singleBlog.title}</h1>
          </div>

          <p className="det">{singleBlog.fulldesc}</p>

          <div className="realted-photos">
            <h2>Related Photos</h2>
            <div className="gallery">
              <img src={urlFor(singleBlog.otherimg1)} alt="" className="gal" />
              <img src={urlFor(singleBlog.otherimg2)} alt="" className="gal" />
              <img src={urlFor(singleBlog.otherimg3)} alt="" className="gal" />
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default SingleBlog;
